exports.ALL = {
	'unskilled': 50,
	'skilled': 85,
	'specialist': 100,
}


// WEBPACK FOOTER //
// ./src/data/occupations.js